import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import Form from 'src/components/FormComponents/Form'
import Submit from 'src/components/FormComponents/Submit'
import { selectProductTabFilters } from 'src/features/stock-management/StockManagementSeletor'
import { actions } from 'src/features/stock-management/StockManagementState'
import { Wrapper } from '../../ReservesTab.styles'
import { TotalItems } from '../Table'
import * as S from './Form.styles'
import { schema } from './Schema'
import { ReservesTabFormValue } from './types'

export default () => {
  const {
    control,
    handleSubmit,
  } = useForm<ReservesTabFormValue>({
    resolver: yupResolver(schema),
  })
  const dispatch = useDispatch()
  const productTabFilters = useSelector(selectProductTabFilters)

  const onSubmit: SubmitHandler<ReservesTabFormValue> = (data) => {
    dispatch(actions.clearProductReserves())
    dispatch(actions.setProductTabsFilters({ ...productTabFilters, ...data }))
    dispatch(actions.getProductReserves())
  }

  return (
    <Wrapper>
      <S.Form as={Form} onSubmit={handleSubmit(onSubmit)}>
        <S.Field
          as={FieldV2}
          labelText='Data inicio:'
          name='startDate'
          control={control}
          type='date'
        />
        <S.Field
          as={FieldV2}
          labelText='Data fim:'
          name='endDate'
          control={control}
          type='date'
        />
        <S.Submit as={Submit} disabled={false} text='Buscar'/>
      </S.Form>
      <TotalItems />
    </Wrapper>
  )
}
